export default __webpack_public_path__ + "static/media/bc1.145b30dd.jpg";